// extracted by mini-css-extract-plugin
export default {"editorSettings":"EditorSettings_editorSettings__lUuLA","editorSettingsButton":"EditorSettings_editorSettingsButton__bTHKP"};